import axios from 'axios';
import { store } from 'react-notifications-component';

//App Settings
import { NetworkSettings } from '@utils';

const RequestApi = axios.create({
  baseURL: NetworkSettings.fullApiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});
RequestApi.interceptors.request.use(
  config => {
    const selectedLanguage = localStorage.getItem("i18nextLng") || "en";
    config.headers['X-App-Language'] = `${selectedLanguage}`;

    const token = localStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = `Basic ${token}`;
    }
    config.auth = {
      'username': NetworkSettings.username,
      'password': NetworkSettings.password,
    }
    return config
  },
  error => Promise.reject(error)
);

RequestApi.interceptors.response.use(
  response => {
    return response.data.result;
  },
  error => {
    if (!error.response.config.url.toLowerCase().includes("/Certificate/employeeCerts?EmployeeID=".toLowerCase()))
      store.addNotification({
        title: "Something Went Wrong",
        message: error.response.data.title,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        },
        isMobile: true
      });


    return Promise.reject(error.response.data);
  }
);

export default RequestApi;